import CNLogo from "../../components/CNLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Logo from "../OnboardingRevampPage/Logo";

export default function PricingNavbar({
  route,
  setExitModal,
  userToggle,
  isCareerGoal,
  setIsCareerGoal,
  defaultState,
}) {
  const navigate = useNavigate();
  const isBlocked = useSelector(
    (store) => store?.userActivity?.user_trial_blocked,
  );
  const prevUrl = useSelector((store) => store?.search?.prevUrl);
  // console.log('navbar' , isCareerGoal?.is_show , defaultState);
  return (
    <>
      <div className="relative flex w-full items-center justify-center bg-white  py-2 px-2 shadow-lg md:px-8">
        {route !== 2 && (
          <div
            className="absolute left-3 flex cursor-pointer items-center justify-between rounded border-2  border-slate-800 bg-white py-2 px-2 text-xs font-bold hover:bg-zinc-50 hover:text-black md:left-10 md:text-sm"
            onClick={(e) => {
              if (isBlocked && isCareerGoal?.is_show) {
                setIsCareerGoal((prev) => ({ ...prev, is_show: false }));
              } else if (isBlocked) {
                setExitModal(true);
              } else if (userToggle) {
                if (prevUrl?.length > 0) {
                  navigate(prevUrl);
                } else {
                  navigate("/courses");
                }
              } else if (defaultState && isCareerGoal?.is_show) {
                setIsCareerGoal((prev) => ({ ...prev, is_show: false }));
                // switch (user_role) {
                //   case 1:
                //     return setActiveCard(cardDatas?.[0]);
                //   case 2:
                //     return setActiveCard(cardDatas?.[1]);
                //   case 4:
                //     return setActiveCard(cardDatas?.[2]);
                //   case 6:
                //     return setActiveCard(cardDatas?.[2]);

                //   default:
                //     break;
                // }
              } else {
                if (prevUrl?.length > 0) {
                  navigate(prevUrl);
                } else {
                  navigate("/courses");
                }
              }
            }}
          >
            <FontAwesomeIcon
              icon={faArrowCircleLeft}
              className="text-lg md:text-base"
            />
          </div>
        )}
        <div className="x-4 flex scale-90 items-center justify-center">
          <a onClick={(event) => {}}>
            <div
              className={`flex w-fit items-center gap-2  rounded-md bg-white  p-2 md:p-2`}
            >
              <img
                src="https://img.learntube.ai/public-assets/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
                loading="eager"
                alt=""
                className="h-[31px] w-[31px] md:h-[35px] md:w-[35px]"
              />
              <p className="text-md font-medium text-black md:flex md:text-lg">
                LearnTube.ai
              </p>
            </div>
          </a>
        </div>
      </div>
    </>
  );
}
